import { EmptySetMessage } from '~/components/content/empty-set-message';
import { getAthleteEvents } from '~/domain/events/handlers/get-athlete-events.server';
import { EventCard } from '~/routes/events+/components/event-card';
import { handleDomainError } from '~/utils/errors.server';
import { getGymIdAndSlugFromParams } from '~/utils/gyms.server';

import { type Route } from './+types/_index';

export async function loader({ params }: Route.LoaderArgs) {
  const { gymId, gymSlug } = await getGymIdAndSlugFromParams(params);
  const eventsResult = await getAthleteEvents(gymId);
  const { rows } = eventsResult.mapErr(handleDomainError).unwrap();
  return {
    gymId,
    gymSlug,
    events: rows,
  };
}

export default function Events({ loaderData }: Route.ComponentProps) {
  return (
    <div className="flex flex-col items-center">
      {loaderData.events.length > 0 ? (
        <div className="flex w-full flex-col gap-y-6">
          {loaderData.events.map((event) => (
            <EventCard key={event.id} event={event} imageLayout="large" includeDetailLink />
          ))}
        </div>
      ) : (
        <EmptySetMessage
          title="No information entered"
          titleClassName="text-subtitle1"
          message="Contact the gym or visit their website to get the latest event information."
          className="p-0 pt-6 text-center"
        />
      )}
    </div>
  );
}
